
import * as React from 'react';
import { fluentSvgIconStyles } from '../../../../styles/iconStyles';

export const Drafts20Regular: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return <svg role="img" focusable="false" aria-hidden viewBox="0 0 20 20" width={20} height={20} fill="currentColor" className={props.className} style={{ ...props.style, ...fluentSvgIconStyles }} onClick={props.onClick}>
        <path
            d="m13.25 2.82-9.61 9.6-.12.13a2 2 0 0 0-.4.76l-1.1 4.06-.02.08a.5.5 0 0 0 .63.53l4.06-1.1.16-.06a2 2 0 0 0 .73-.46l9.6-9.6.13-.15a2.78 2.78 0 0 0-4.06-3.8Zm-8.9 10.31 8.04-8.04 2.52 2.52-8.04 8.04-.1.09-.1.07a1 1 0 0 1-.25.1l-3.2.87.87-3.2.04-.13a1 1 0 0 1 .22-.32Zm12.12-9.6.11.11c.59.7.55 1.75-.1 2.4l-.87.87-2.52-2.53.86-.86.12-.1c.7-.59 1.75-.55 2.4.1ZM11.65 3H2.5a.5.5 0 0 0 0 1h8.15l1-1Zm-3 3H2.5a.5.5 0 0 0 0 1h5.15l1-1Zm-4 4 1-1H2.5a.5.5 0 0 0 0 1h2.15Z"
            fill="currentColor"
        />
    </svg>
}